import { useRef } from 'react';
import { useInterpret } from '@xstate/react';
import { useClient } from 'urql';
import type { ActorRefFrom } from 'xstate';

import { createAuthMachine } from './AuthMachine';
import { AuthStorage } from './AuthStorage';

export type AuthMachineRefType = ActorRefFrom<
  ReturnType<typeof createAuthMachine>
>;

export const useInitAuthMachine = () => {
  const client = useClient();
  const { current: AuthMachine } = useRef(createAuthMachine(client));

  const authMachineRef = useInterpret(AuthMachine, {
    actions: {
      async saveCsrfTokenToStorage(_context, event) {
        await AuthStorage.setToken(event.csrfToken);
      },
    },
  });

  return authMachineRef;
};
